import React from "react";

interface LinkProps {
  onClick: () => void;
  disabled?: boolean;
  label: string;
}

export const Link = ({
  onClick,
  disabled = false,
  label,
}: LinkProps) => (
  <button
    onClick={onClick}
    className={`${
      disabled
        ? 'text-gray-900 font-medium cursor-default'
        : 'transition-all duration-200 text-teal-600 hover:underline hover:scale-105 active:scale-95'
    }`}
    disabled={disabled}
  >
    {label}
  </button>
)